import ajax from './ajax'

//登录
export const login = (username,password)=>ajax('/admin/user/login',{username,password},'POST',);
//注册
export const register = (username,identity,password,name,address,school,pcode)=>ajax('/api/mg/user/register',{username,identity,password,name,address,school,pcode},'POST',);
//获取学习时长信息
export const search = (username)=>ajax('/api/mg/user/search',{username},'POST',);
//获取所有用户的信息
export const getUserInfo = (pageNum,limit,input)=>ajax('/admin/cyl/list',{pageNum,limit,input});
//获取所有用户的权限信息
export const getUserAuthInfo = (pageNum,limit,input)=>ajax('/admin/stock/list',{pageNum,limit,input});
//获取用户的组信息
export const getGroup = (row,edit)=>ajax('/api/mg/user/group',{row,edit});
//更新 用户的权限组信息
export const updateUserAuthInfo = (id,status,user_id)=>ajax('/api/mg/user/auth_update',{id,status,user_id},'POST');

//更新用户登陆状态
export const updateUserInfo = (uid,status_code)=>ajax('/admin/cyl/update',{uid,status_code},'POST',);
export const deleteUserInfo = (uid)=>ajax('/admin/cyl/delete',{uid},'POST',);
export const overUserInfo = (uid)=>ajax('/admin/xlsx/overwrite',{uid},'POST',);
export const DownloadXlsl = (uid)=>ajax('/admin/xlsx/download',{uid},'POST',);
export const updateCylRank = (uid,type)=>ajax('/admin/cyl/rank',{uid,type},'POST',);
//获取管理员信息
// export const getAdminInfo = (adminId)=>ajax('/admin/user/getAdminInfo',{adminId});
//获取当前页电影
export const getCurrentPageMovie = (pageNum,limit,input)=>ajax('/admin/movie/getMovies',{pageNum,limit,input});
//上传文件到服务器
export const upLoadFile = (formData)=>ajax('/admin/movie/upLoadFile',formData,'POST');
//更新/添加电影信息
export const updateMovieInfo = (movie)=>ajax('/admin/movie/addMoive',{movie},'POST');
//删除电影信息
export const deleteMovieInfo = (movieId)=>ajax('/admin/movie/deleteMovie',{movieId},'POST');
//获取当前页用户评论
export const getComments = (page,limit,keyword)=>ajax('/admin/order/list',{page,limit,keyword});
//通过当前评论
// export const passCurrentComment = (commentId,movieId)=>ajax('/api/admin/passCurrentComment',{commentId,movieId},'POST');
//删除当前评论
export const deleteComment = (commentId)=>ajax('/admin/comment/deleteComment',{commentId},'POST');
//获取当前页用户
export const getCurrentPageUser = (pageNum,limit,input)=>ajax('/admin/user/getUsers',{pageNum,limit,input});
//禁用/解禁用户
export const banUserById = (userId)=>ajax('/admin/user/banUser',{userId},'POST');
//删除用户信息
// export const deleteUserInfo = (userId)=>ajax('/api/admin/deleteUserInfo',{userId},'POST');
//更新用户信息
//export const updateUserInfo = (userId,userName,avatar,password,sex,phone,sign,birthday)=>ajax('/api/admin/updateUserInfo',{userId,userName,avatar,password,sex,phone,sign,birthday},'POST');
//添加用户信息
//export const addUserInfo = (userName,avatar,phone,password,sex,sign,birthday)=>ajax('/api/admin/addUserInfo',{userName,avatar,phone,password,sex,sign,birthday},'POST');
//获取当前页小吃
export const getSnacks = (pageNum,limit,keyword)=>ajax('/admin/snack/getSnacks',{pageNum,limit,keyword});
//编辑/添加小吃
export const updateSnackInfo = (snack)=>ajax('/admin/snack/addSnack',{snack},'POST');
//删除小吃
export const deleteSnackInfo = (snackId)=>ajax('/admin/snack/deleteSnack',{snackId},'POST');
//获取当前页订单
export const getCurrentPageOrder = (pageNum,limit,keyword)=>ajax('/admin/article/list',{pageNum,limit,keyword});
//删除订单
export const deleteOrder = (id)=>ajax('/admin/article/delete',{id},'POST');
export const topOrder = (id)=>ajax('/admin/article/top',{id},'POST');
//获取当前页影院
export const getCurrentPageCinema = ()=>ajax('/admin/miniapp/price_config',{});
//获取影院品牌列表
export const getBrandList = ()=>ajax('/admin/cinema/getBrandList',{});
//更新/添加影院信息
export const updateCinemaInfo = (cinema)=>ajax('/admin/cinema/addCinema',{cinema},'POST');
//删除影院信息
export const deleteCinemaInfo = (id)=>ajax('/api/mg/deleteCinema',{id},'POST');
//增加影院品牌
export const addCinemaBrand = (data)=>ajax('/admin/miniapp/update_price_config',{data},'POST');
//获取当前页影厅
export const getCurrentPageHall = (pageNum,limit,input)=>ajax('/api/mg/getHalls',{pageNum,limit,input});
//获取Options
export const getOptions = ()=>ajax('/api/mg/getOptions',{});
//更新影厅信息
export const updateHallInfo = (id,xk,module_name,xd,nj,xq)=>ajax('/api/mg/updateHall',{id,xk,module_name,xd,nj,xq},'POST');
//删除影厅
export const deleteHall = (hallId)=>ajax('/admin/hall/deleteHall',{hallId},'POST');
//添加影厅
export const addHall = (xd,nj,xk,module_name)=>ajax('/api/mg/addHall',{xd,nj,xk,module_name},'POST');
//获取影厅座位信息
export const getSeats = (hallId)=>ajax('/admin/hall/getSeatByHallId',{hallId});
//修改座位信息
export const commitSeat = (hallId,newSeat,changeSeat)=>ajax('/admin/hall/commitSeat',{hallId,newSeat,changeSeat},'POST');
//获取当前页排片
export const getCurrentPageMovieSchedule = (pageNum,limit,keyword)=>ajax('/admin/schedule/getMovieSchedule',{pageNum,limit,keyword});
//删除电影排片
export const deleteMovieSchedule = (timesId,daysId)=>ajax('/admin/schedule/deleteMovieSchedule',{timesId,daysId},'POST');
//获取所有电影和影院
export const getOptions2 = ()=>ajax('/admin/schedule/getOptions');
//获取所有影厅
export const getHallByCinemaId = (cinemaId)=>ajax('/admin/schedule/getHallByCinema',{cinemaId});
//添加排片信息
export const addScheduleInfo = (movieId,cinemaId,hallId,showDate,showTime,price)=>ajax('/admin/schedule/addScheduleInfo',{movieId,cinemaId,hallId,showDate,showTime,price},'POST');
//获取当前页广告
export const getBanner = (id)=>ajax('/admin/cyl/info',{id});
//更新/添加广告
export const updateBannerInfo = (banner)=>ajax('/admin/cyl/info/update',{banner},'POST');
export const updateStockInfo = (banner)=>ajax('/admin/stock/edit',{banner},'POST');
export const addStockInfo = (banner)=>ajax('/admin/stock/add',{banner},'POST');
export const addBannerInfo = (banner)=>ajax('/admin/cyl/info/add',{banner},'POST');
//删除广告
export const deleteBannerInfo = (stockId)=>ajax('/admin/cyl/info/delete',{stockId},'POST')
export const update_word = (sid,word)=>ajax('/admin/cyl/info/update_word',{sid,word},'POST')
export const UpdateWord = (data)=>ajax('/admin/article/update_word',{data},'POST')
export const GetSubjectWord = (sid)=>ajax('/admin/cyl/info/get_word',{sid})
export const GetArticleWord = (aid)=>ajax('/admin/article/get_word',{aid})

//获取当前页管理员
export const getCurrentPageAdmin = (page,size,keyword)=>ajax('/admin/user/list',{page,size,keyword});
//获取Options
export const getOptions3 = ()=>ajax('/admin/auser/getOptions',{});
//修改管理员信息
export const updateAdminInfo = (id,vip_at)=>ajax('/admin/user/update',{id,vip_at},'POST');

//商家=====================================================================================================================
//获取当前页影厅
export const getCurrentPageBHall = (pageNum,limit,keyword,uid)=>ajax('/api/mg/user/getHalls',{pageNum,limit,keyword,uid});
export const addPcode = (uid)=>ajax('/api/mg/user/pcode',{uid});
//获取当前页排片
export const getCurrentPageBMovieSchedule = (pageNum,limit,keyword,cinemaId)=>ajax('/admin/schedule/getMovieSchedule',{pageNum,limit,keyword,cinemaId});
//获取当前页订单
export const getCurrentPageBOrder = (pageNum,limit,input,xd,grade,subject,version,volume)=>ajax('/api/mg/getOrders',{pageNum,limit,input,xd,grade,subject,version,volume});
//获取当前章节的所有视频列表
export const getCardPageBOrder = (pageNum,limit,z,j,t,grade)=>ajax('/api/mg/getCrads',{pageNum,limit,z,j,t,grade});

//获取当前用户的套餐列表
export const getBSnacks = (pageNum,limit,keyword,uid)=>ajax('/api/mg/getSnacks',{pageNum,limit,keyword,uid});
//获取当前用户的跳转账号和密码
export const getPass = (desc,ranges)=>ajax('/api/mg/get_jump_user',{desc,ranges});
//获取播放地址
export const getVideoUrl = (video,uid)=>ajax('/api/mg/app/video',{video,uid},'POST',);



// WEBPACK FOOTER //
// ./src/api/index.js